import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { MessagesService } from '../../../services/api.services';
import { ProformaData } from '../proforma.data';
import { ModalController } from '@ionic/angular';
import { ElipsisModalComponent } from '../../shared/elipsis-modal/elipsis-modal.component';

@Component({
  selector: 'app-proforma-escritorio',
  templateUrl: './proforma-escritorio.component.html',
  styleUrls: ['./proforma-escritorio.component.scss'],
})
export class ProformaEscritorioComponent implements OnInit {

  @Input() proformaData: ProformaData;

  @Output() giveMeProformas = new EventEmitter();
  @Output() rowSelected = new EventEmitter();

  ColumnMode = ColumnMode;
  SelectionType = SelectionType;
  selected = [];

  constructor(private router: Router,
              private messages: MessagesService,
              private modalCtrl: ModalController) {}

  ngOnInit() {
    this.messages.onInitTranslateService().subscribe( () => {
    });
  }

  onClick(row: any) {
    this.router.navigate(['main', 'lineas-proforma', row.id]);
  }

  setPage(pageInfo) {
    this.proformaData.page.offset = pageInfo.offset;
    const envio = {
      page: this.proformaData.page,
      total: this.proformaData.page.count
    };
    this.giveMeProformas.emit(envio);
  }

  async abrirDescripcion(value: string) {
    if (value && value.length > 0) {
      const modal = await this.modalCtrl.create({
        component: ElipsisModalComponent,
        componentProps: {
          isModal: true,
          descripcion: value
        }
      });
      await modal.present();
    }
  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
    if (this.selected.length !== 0) {
      this.rowSelected.emit(this.selected);
    } else {
      this.rowSelected.emit(false);
    }
  }

  getCellClass({ row, column, value }): any {
    if (column.prop === 'amount') {
      return {
        'cell-right-position': true
      };
    }

    if (column.prop === 'state_name') {
      return {
        'cell-center-position': true
      };
    }
  }

  getHeaderClass({ row, column, value }): any {
    if (column.prop === 'amount') {
      return {
        'cell-right-position': true
      };
    }

    if (column.prop === 'state_name') {
      return {
        'cell-center-position': true
      };
    }
  }
}
